export default{
    containerStyles:{
      width:"100%",
      height: 65,
      backgroundColor: "#F7F7F7",
      position: "absolute",
      display: "block",
      borderTop: "2px solid #e2e2e2",
      borderBottom: "2px solid #e2e2e2",
      marginTop:"24px",
    },
    innerContainerStyles:{
      width:"100%",
      maxWidth:"1200px",
      marginRight:"auto",
      marginLeft:"auto",        
    },
    menuIconStyles:{
      width:"38px",
      marginLeft:"auto",
      marginRight:"auto", 
      height:"20px",
    },
    menuToggleContainer:{
      border:"none",
      backgroundColor:"#B2D23E",
      cursor:"pointer",
      position:"absolute",
      float:"left",
      padding:"0",
      marginLeft:"0px",
      textAlign:"center",
      zIndex:"7000",
      display:"block",
      height:"60px",
      width:"67px",
      fontSize:"10px",
    },
    menuToggle:{
      border: "0px",
      textTransform: "uppercase",
      fontSize: "14px",
      color: "rgb(1, 83, 63)",
      fontWeight: "900",
      fontFamily: "Roboto",
      paddingTop:"4px",
    },
    visible:{
      position:"absolute",
      left:"-1500px",
      top:"auto",
      width:"1px",
      height:"1px",
      overflow:"hidden",
      zIndex:"6000",
    },
    modal:{
      position: "fixed",
      top: "20",
      right: "0",
      bottom: "0",
      left: "0",
      background: "rgba(0,0,0,0.8)",
      zIndex: "5000",
      opacity: "0",
      WebkitTransition: "opacity 400ms ease-in",
      MozTransition: "opacity 400ms ease-in",
      transition: "opacity 400ms ease-in",
      pointerEvents: "none"
    },
    grouptitle:{
      fontFamily: "Roboto",
      fontWeight:"500",
      color: "#01533F",
      letterSpacing: "0.82px",
      textAlign: "left",
      textTransform:"uppercase",
      position:"absolute",
      top:"50%",
      transform:"translate(0, -50%)",
      margin:"0 0 0 88px",
    }
}
